import { NavLink } from "react-router-dom";
import { Home, CalendarDays, Ticket, User } from "lucide-react";
import { useLang } from "../context/LangContext";

const items = [
  { to: "/home", icon: Home, key: "home", testid: "nav-home" },
  { to: "/calendar", icon: CalendarDays, key: "calendar", testid: "nav-calendar" },
  { to: "/trips", icon: Ticket, key: "trips", testid: "nav-trips" },
  { to: "/profile", icon: User, key: "profile", testid: "nav-profile" },
];

export function BottomNav() {
  const { t } = useLang();
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 mx-auto max-w-[480px] safe-bottom"
      data-testid="bottom-nav"
    >
      <div className="mx-3 mb-10 rounded-2xl border border-brand-tan/30 bg-brand-cream/85 backdrop-blur-xl shadow-[0_10px_30px_-12px_rgba(60,40,24,0.25)]">
        <ul className="flex items-center justify-between px-4 py-2">
          {items.map(({ to, icon: Icon, key, testid }) => (
            <li key={key} className="flex-1">
              <NavLink
                to={to}
                data-testid={testid}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-1 py-2 transition-all ${
                    isActive
                      ? "text-brand-brown"
                      : "text-brand-tan hover:text-brand-brown"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon
                      size={20}
                      strokeWidth={isActive ? 2 : 1.5}
                      className="transition-transform duration-300 ease-out"
                    />
                    <span
                      className={`text-[10px] tracking-[0.2em] uppercase ${
                        isActive ? "font-bold" : "font-medium"
                      }`}
                    >
                      {t(key)}
                    </span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default BottomNav;
